<template>
  <!-- Backdrop -->
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    @click.self="$emit('resolved')"
  >
    <div class="bg-slate-800 border border-slate-600 rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
      <!-- Header -->
      <div class="px-5 py-4 border-b border-slate-700 flex items-start gap-3">
        <div class="w-8 h-8 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg class="w-4 h-4 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div>
          <h2 class="text-sm font-semibold text-white">Datasets not found in library</h2>
          <p class="text-xs text-slate-400 mt-0.5">
            This design references {{ missing.length }} dataset{{ missing.length !== 1 ? 's' : '' }} that
            {{ missing.length !== 1 ? 'are' : 'is' }} not in your Dataset Library.
          </p>
        </div>
      </div>

      <!-- Dataset list -->
      <div class="divide-y divide-slate-700 max-h-64 overflow-y-auto">
        <div
          v-for="ds in missing"
          :key="ds.uuid"
          class="flex items-center gap-3 px-5 py-3"
        >
          <div class="flex-1 min-w-0">
            <div class="text-sm text-slate-200 truncate">{{ ds.name }}</div>
            <div class="text-xs text-slate-500 font-mono truncate">{{ ds.uuid }}</div>
            <div class="text-xs text-slate-500">id: {{ ds.id }} &bull; {{ (ds.series ?? []).length }} series</div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button
              v-if="!importedUUIDs.has(ds.uuid)"
              class="text-xs px-3 py-1.5 rounded bg-cyan-600 hover:bg-cyan-500 text-white transition-colors"
              @click="importDataset(ds)"
            >Import</button>
            <span
              v-else
              class="text-xs px-3 py-1.5 rounded bg-green-700/50 text-green-300 border border-green-600/40"
            >Imported</span>
            <button
              v-if="!importedUUIDs.has(ds.uuid)"
              class="text-xs px-3 py-1.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-300 transition-colors"
              @click="skipDataset(ds.uuid)"
            >Skip</button>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="px-5 py-3 border-t border-slate-700 flex items-center justify-between">
        <button
          class="text-xs text-cyan-400 hover:text-cyan-300 transition-colors"
          @click="importAll"
        >Import all</button>
        <button
          class="text-xs px-4 py-1.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-300 transition-colors"
          @click="$emit('resolved')"
        >Done</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useDatasetStore } from '../../stores/datasetStore.js'

const props = defineProps({
  show:    { type: Boolean, default: false },
  missing: { type: Array,   default: () => [] },
})
defineEmits(['resolved'])

const store = useDatasetStore()
const importedUUIDs = ref(new Set())
const skippedUUIDs = ref(new Set())

function importDataset(snapshot) {
  store.importSnapshot(snapshot)
  importedUUIDs.value.add(snapshot.uuid)
  importedUUIDs.value = new Set(importedUUIDs.value) // trigger reactivity
}

function skipDataset(uuid) {
  skippedUUIDs.value.add(uuid)
  skippedUUIDs.value = new Set(skippedUUIDs.value)
}

function importAll() {
  for (const ds of props.missing) {
    if (!importedUUIDs.value.has(ds.uuid)) {
      importDataset(ds)
    }
  }
}
</script>
